import { createSelector } from '@reduxjs/toolkit';
import { OrderedMap } from 'immutable';

import { undoSelectors } from 'app-components/flux/undo';

import { NOTIFICATIONS_REDUCER_KEY } from './notificationsReducer';
import { notificationFromUndo } from './notificationsUtils';

// @ts-expect-error FIXME TS7053
const getStore = (state: object) => state[NOTIFICATIONS_REDUCER_KEY];

export const getNotifications = createSelector(
  (state) => getStore(state).notifications,
  undoSelectors.getUndoStack,
  (notifications, undoStack) => {
    // @ts-expect-error FIXME TS7006
    const undoNotifications = OrderedMap(undoStack.map((undo) => [undo.key, notificationFromUndo(undo)]));
    return (
      notifications
        .merge(undoNotifications)
        // @ts-expect-error FIXME TS7006
        ?.sortBy((notification) => notification.createdAt)
        .toIndexedSeq()
        // @ts-expect-error FIXME TS7006
        .groupBy((notification) => `${notification.anchorOrigin.vertical}:${notification.anchorOrigin.horizontal}`)
        // @ts-expect-error FIXME TS7006
        .flatMap((notificationsGroup) =>
          OrderedMap(
            // @ts-expect-error FIXME TS7006
            notificationsGroup.map((notification, anchorIndex) => [
              notification.id,
              notification.merge({ anchorIndex }),
            ]),
          ),
        )
    );
  },
);

export const getNotificationById = (state: object, id: string) => getNotifications(state).get(id);
